import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { environment } from '../../../environments/environment'

/** Tag SDB di un frazionario. Un frazionario può averne più di uno. */
export interface SdbTag {
  id: number
  code: string
  label: string
}

export interface SdbTagCatalogItem extends SdbTag {
  count: number
}

export interface SdbTagSyncStatus {
  lastSyncAt: string | null
  rows: number
  unmatched: number
  tags: number
}

@Injectable({
  providedIn: 'root'
})
export class AwpSdbTagsApiService {
  private readonly http = inject(HttpClient)
  private readonly fuseqHeaders = inject(FuseqHeaders)

  private base (): string {
    return `${environment.API_URL}/sdbTags`
  }

  getCatalog (): Observable<SdbTagCatalogItem[]> {
    return this.http.get<SdbTagCatalogItem[]>(`${this.base()}/catalog`, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getByFraz (fraz: string): Observable<SdbTag[]> {
    return this.http.get<SdbTag[]>(`${this.base()}/frazionario/${encodeURIComponent(fraz)}`, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getBatch (frazionari: string[]): Observable<Record<string, SdbTag[]>> {
    return this.http.post<Record<string, SdbTag[]>>(`${this.base()}/batch`, { frazionari }, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getByTag (code: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.base()}/by-tag/${encodeURIComponent(code)}`, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getStatus (): Observable<SdbTagSyncStatus> {
    return this.http.get<SdbTagSyncStatus>(`${this.base()}/status`, this.fuseqHeaders.setTokenHeaders('GET'))
  }
}
